<template>
<div class="sqdList">
  <iframe class="znr" ref="prints" :src="srcs"></iframe>
</div>
</template>

<script>
export default {
  name: "sqdList",
  data() {
    return {
      srcs: ''
    }
  },
  created() {
    let num = this.$route.query.num
    let src = ''
    switch (num) {
      case '1':
        src = this._getUrl('Page_OperationCHPPrint')
        src.replace("{ChooseId}", this.$store.state.physicianVisits.xzConsulting)
        src.replace("{ExpertId}", this.$store.state.users.employees.ExpertId)
        break
      case '2':
        src = this._getUrl('Page_LabtestCHPPrint')
        src.replace("{ChooseId}", this.$store.state.physicianVisits.xzConsulting)
        src.replace("{ExpertId}", this.$store.state.users.employees.ExpertId)
        break
      case '3':
        src = this._getUrl('Page_ExamCHPPrint')
        src.replace("{ChooseId}", this.$store.state.physicianVisits.xzConsulting)
        src.replace("{ExpertId}", this.$store.state.users.employees.ExpertId)
        break
      case '4':
        src = this._getUrl(':Page_TreatmentCHPPrint')
        src.replace("{ChooseId}", this.$store.state.physicianVisits.xzConsulting)
        src.replace("{ExpertId}", this.$store.state.users.employees.ExpertId)
        break
    }
    this.srcs = src
  }
}
</script>

<style scoped>
.znr {
  width: 98vw;
  height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
